import React from 'react';
import {
  Box,
  BoxProps,
  HStack,
  Icon,
  IconProps,
  Label,
  LabelProps,
  Text,
  TextProps,
} from '@medely/ui-kit';

type BannerProps = {
  bgColor: BoxProps['bgColor'];
  iconColor: IconProps['color'];
  title: LabelProps['children'];
  subtitle?: TextProps['children'];
};

export const Banner = ({ bgColor, title, subtitle, iconColor }: BannerProps) => {
  return (
    <Box py={1}>
      <Box bgColor={bgColor} p={2} borderRadius="10px">
        <HStack gap={2}>
          <Icon name="arrows-repeat" variant="custom" color={iconColor} />
          <Box>
            <Label size="m" color={iconColor}>
              {title}
            </Label>
            {subtitle && (
              <Text size="m" color="text.secondary">
                {subtitle}
              </Text>
            )}
          </Box>
        </HStack>
      </Box>
    </Box>
  );
};
